import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  public show: boolean = true;
  public cadena:string='';

  constructor() {
    this.cadena=window.location.pathname;
    if(this.cadena.indexOf('/principal')!=-1||this.cadena=='/sigrrhh'||this.cadena=='/sigrrhh/'){
      setTimeout(() => {
        this.show = false;
      }, 5000);
    }else{
      this.show=false;
    }
    
  }

  ngOnInit() { }

  ngOnDestroy() { }

}
